// Options de réponse en dur : `value` est la valeur enregistrée (inchangée, en français),
// `cle` la clé de traduction du libellé affiché.
export interface RadioOption {
    value: string;
    cle: string;
}

export const RADIO_OPTIONS_SATISFACTION: RadioOption[] = [
    { value: 'Oui', cle: 'satisfaction.option.oui' },
    { value: 'Non', cle: 'satisfaction.option.non' },
    { value: 'Ne se prononce pas', cle: 'satisfaction.option.nsp' },
];
export const RADIO_OPTIONS_RELANCE: RadioOption[] = [
    { value: 'Ne plus demander', cle: 'satisfaction.relance.ne_plus_demander' },
    { value: 'Me relancer dans 3 mois', cle: 'satisfaction.relance.dans_3_mois' },
];

export const getRadioOptions = (type: string): RadioOption[] => {
    switch (type) {
        case 'satisfaction':
            return RADIO_OPTIONS_SATISFACTION;
        case 'relance':
            return RADIO_OPTIONS_RELANCE;
        default:
            return [];
    }
};
